

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import TestC from './TestC.vue';

@Component
export default class InputVarAutocomplete extends Vue {
  @Prop()
  public inputId: any;

  @Prop()
  public input: any;

  @Prop()
  public variables!: string[];

  @Prop({ default: '' })
  public value: any;

  @Prop()
  public emit: any;

  public component: InputVarAutocomplete | null = null;
  public showList = false;
  public currentSelection: string | null = null;
  public currentSelectionIndex = -1;
  public dropdownPos = { x: 0, y: 0 };
  public text = '';
  public varSearch = '';
  public cursorPosition = -1;

  public getVarSearch(): string {
    const cursorPos = this.input.selectionStart;
    const substr = this.value.substring(0, cursorPos);
    const lastStartOfVar = substr.lastIndexOf('${');

    this.varSearch = substr.substring(lastStartOfVar + 2, cursorPos);
    return this.varSearch;
  }

  public get filteredVariables(): string[] {
    return this.variables.filter((variable) => {
      return variable.toLowerCase().includes(this.varSearch.toLowerCase());
    });
  }

  public checkEditing(): void {
    if (this.isEditingVar()) {
      this.getVarSearch();
      this.dropdownPos = getCursorXY(this.input, this.input.selectionStart);
      this.showList = true;

      if (
        !(
          this.currentSelectionIndex >= 0 &&
          this.currentSelectionIndex < this.filteredVariables.length
        )
      ) {
        this.currentSelectionIndex = 0;
      }

      this.selectVar();
    } else {
      this.showList = false;
      this.currentSelectionIndex = 0;
    }
  }

  public mounted(): void {
    if (this.inputId) {
      const input = document.getElementById(this.inputId);
      const tempDiv = document.createElement('div');
      if (input && input.parentElement) {
        input.parentElement.style.position = 'relative';
        input.parentElement.appendChild(tempDiv);
      }

      this.component = new InputVarAutocomplete({
        el: tempDiv,
        propsData: {
          input,
          variables: this.variables,
          value: this.value,
          emit: (event: any, ...args: any[]): void =>
            void this.$emit(event, ...args),
        },
      });

      return;
    }

    if (this.input) {
      this.input.addEventListener('input', (e: any) => {
        this.text = this.input.value;

        if (e.data === '$') {
          const cursorPos = this.input.selectionStart;
          const strStart = this.text.substring(0, cursorPos);
          const strEnd = this.text.substring(cursorPos);

          this.emit('input', [strStart, '{}', strEnd].join(''));
          this.input.value = [strStart, '{}', strEnd].join('');
          this.input.selectionStart = this.input.selectionEnd = cursorPos + 1;
        }
        this.checkEditing();
      });

      this.input.addEventListener('click', () => {
        const cursorPos = this.input.selectionStart;
        this.cursorPosition = cursorPos;
        this.checkEditing();
      });

      this.input.addEventListener('keyup', () => {
        const cursorPos = this.input.selectionStart;

        if (this.cursorPosition !== cursorPos) {
          this.cursorPosition = cursorPos;
          this.checkEditing();
        }
      });

      this.input.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.keyCode === 40 && this.showList) {
          e.preventDefault();
          this.selectNextVar();
        }

        if (e.keyCode === 38 && this.showList) {
          e.preventDefault();

          this.selectPrevVar();
        }

        if (e.keyCode === 13 && this.showList) {
          e.preventDefault();

          this.addVarSelectedToInput();
        }

        if (e.keyCode === 8) {
          // e.preventDefault();
          const cursorPos = this.input.selectionStart;

          if (this.isEndOfVar(cursorPos - 1)) {
            e.preventDefault();
            // Rebuild str with ${}
            const lastStartOfVar = this.input.value
              .substring(0, cursorPos - 1)
              .lastIndexOf('${');

            const startStr = this.value.substring(0, lastStartOfVar + 2);
            const endStr = this.value.substring(cursorPos);

            this.emit('input', [startStr, '}', endStr].join(''));
            this.input.value = [startStr, '}', endStr].join('');
            this.input.selectionStart = this.input.selectionEnd =
              lastStartOfVar + 2;
            return;
          }

          if (this.isAtVarDefStart(cursorPos) && this.varSearch === '') {
            e.preventDefault();
            // Remove var def

            const startOfVar = this.input.value
              .substring(0, cursorPos)
              .lastIndexOf('$');
            const endOfVar =
              this.value.substring(cursorPos).indexOf('}') + cursorPos;

            const startStr = this.value.substring(0, startOfVar);
            const endStr = this.value.substring(endOfVar + 1);

            this.emit('input', startStr + endStr);
            this.input.value = startStr + endStr;
            this.input.selectionStart = this.input.selectionEnd =
              startStr.length;
          }
        }
      });

      //   this.input.addEventListener('blur', () => {
      //     this.showList = false;
      //   });
    }

    // comp.$mount();
  }

  // Inside def at start or between $ sign and {
  public isAtVarDefStart(index: number): boolean {
    return (
      this.value.substr(index - 2, 2) === '${' ||
      (this.input.value[index - 1] === '$' && this.input.value[index] === '{')
    );
  }

  public isEndOfVar(index: number): boolean {
    const lastStartOfVar = this.input.value
      .substring(0, index)
      .lastIndexOf('${');

    if (lastStartOfVar < 0) {
      return false;
    }

    if (this.value.substring(lastStartOfVar, index).indexOf('}') > 0) {
      return false;
    }

    if (this.input.value[index] !== '}') {
      return false;
    }

    return true;
  }

  public selectPrevVar(): void {
    this.currentSelectionIndex--;

    if (this.currentSelectionIndex < 0) {
      this.currentSelectionIndex = this.filteredVariables.length - 1;
    }

    this.selectVar();
  }

  public selectNextVar(): void {
    this.currentSelectionIndex++;

    if (this.currentSelectionIndex >= this.filteredVariables.length) {
      this.currentSelectionIndex = 0;
    }

    this.selectVar();
  }

  public selectVar(): void {
    this.currentSelection = this.filteredVariables[this.currentSelectionIndex];
  }

  public addVarSelectedToInput(): void {
    const cursorPos = this.input.selectionStart;
    const substr = this.value.substring(0, cursorPos);

    const lastDollarIndex = substr.lastIndexOf('$');

    const strStart = this.value.substring(0, lastDollarIndex + 2);
    const endOfVar = this.value.substring(lastDollarIndex).indexOf('}');
    const strEnd = this.value.substring(lastDollarIndex + endOfVar);


    this.emit('input', [strStart, this.currentSelection, strEnd].join(''));
    this.input.value = [strStart, this.currentSelection, strEnd].join('');
    this.input.selectionStart = this.input.selectionEnd =
      (strStart + this.currentSelection).length + 1;
  }

  public isEditingVar(): boolean {
    const cursorPos = this.input.selectionStart;
    const substr = this.value.substring(0, cursorPos);

    const lastDollarIndex = substr.lastIndexOf('${');

    if (lastDollarIndex < 0) {
      return false;
    }

    const potentialVarEdited = substr.substring(lastDollarIndex, cursorPos);


    if (potentialVarEdited.indexOf(' ') >= 0) {
      return false;
    }

    if (potentialVarEdited.indexOf('\n') >= 0) {
      return false;
    }

    if (potentialVarEdited.indexOf('}') >= 0) {
      return false;
    }

    return true;
  }

  @Watch('value', { immediate: true })
  public valueCh(): void {
    if (this.component) {
      this.component.$props.value = this.value;
    }
  }

  @Watch('variables', { immediate: true })
  public variablesCh(): void {
    if (this.component) {
      this.component.$props.variables = this.variables;
    }
  }

  public beforeDestroy(): void {
    if (this.component) {
      this.component.$destroy();
    }
  }
}

/**
 ns xrdinr abposi o
 *
 * @param {object} input - the input element to obtain coordinates for
 * @param {number} selectionPoint - the selection point for the input
 */
const getCursorXY = (
  input: HTMLInputElement,
  selectionPoint: number,
): { x: number; y: number } => {
  const { offsetLeft: inputX, offsetTop: inputY } = input;

  //   var rect = input.getBoundingClientRect();
  //   const inputX = rect.left;
  //   const inputY = rect.top;
  // create a dummy element that will be a clone of our input
  const div = document.createElement('div');
  // get the computed style of the input and clone it onto the dummy element
  const copyStyle = getComputedStyle(input) as any;
  for (const prop of copyStyle) {
    div.style[prop] = copyStyle[prop];
  }
  // we need a character that will replace whitespace when filling our dummy element if it's a single line <input/>
  const swap = '.';
  const inputValue =
    input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value;
  // set the div content to that of the textarea up until selection
  const textContent = inputValue.substr(0, selectionPoint);
  // set the text content of the dummy element div
  div.textContent = textContent;
  if (input.tagName === 'TEXTAREA') {
    div.style.height = 'auto';
  }
  // if a single line input then the div needs to be single line and not break out like a text area
  if (input.tagName === 'INPUT') {
    div.style.width = 'auto';
  }
  // create a marker element to obtain caret position
  const span = document.createElement('span');
  // give the span the textContent of remaining content so that the recreated dummy element is as close as possible
  span.textContent = inputValue.substr(selectionPoint) || '.';
  // append the span marker to the div
  div.appendChild(span);
  // append the dummy element to the body
  document.body.appendChild(div);
  // get the marker position, this is the caret position top and left relative to the input
  const { offsetLeft: spanX, offsetTop: spanY } = span;
  // lastly, remove that dummy element
  // NOTE:: can comment this out for debugging purposes if you want to see where that span is rendered
  document.body.removeChild(div);
  // return an object with the x and y of the caret.
  // account for input positioning so that you don't need to wrap the input

  const wrapper = input.parentElement;
  const inputRect = input.getBoundingClientRect();
  let distXFromWrapper = 0;
  let distYFromWrapper = 0;

  if (wrapper) {
    const wrapperRect = wrapper.getBoundingClientRect();
    distXFromWrapper = inputRect.left - wrapperRect.left;
    distYFromWrapper = inputRect.top - wrapperRect.top;
  }

  return {
    x: inputX + spanX + distXFromWrapper + 10,
    y: inputY + spanY + distYFromWrapper + 20,
  };
};
